import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyBThA9ew2qUbQWuFbf6N7HSbfUEEqUTNHw",
  authDomain: "mycliniq-d086f.firebaseapp.com",
  projectId: "mycliniq-d086f",
  storageBucket: "mycliniq-d086f.firebasestorage.app",
  messagingSenderId: "429696902617",
  appId: "1:429696902617:web:80dbbd8ad1c645f3b4a5c8",
  measurementId: "G-5E6GXTPDMK"
};
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };
